/**
 * Login Page
 *
 * เข้าสู่ระบบด้วย Google พร้อม Lottie animation
 */

import { useState } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

export default function LoginPage() {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { signInWithGoogle } = useAuth();

  const handleGoogleSignIn = async () => {
    setError('');
    setLoading(true);

    try {
      await signInWithGoogle();
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'ไม่สามารถเข้าสู่ระบบด้วย Google ได้';
      setError(message);
      setLoading(false);
    }
  };

  return (
    <div
      className="h-dvh max-h-dvh w-full max-w-screen mx-auto flex flex-col overflow-hidden bg-linear-to-b from-[#bae6fd] via-sky-100 to-[#1e1b4b]"
      style={{
        background:
          'linear-gradient(180deg, #bae6fd 0%, #7dd3fc 25%, #38bdf8 50%, #1d4ed8 75%, #1e1b4b 100%)',
      }}
    >
      {/* Lottie - อยู่ส่วนบน (flex-1 + min-h-0 ให้ fit ไม่ overflow) */}
      <div className="flex-1 min-h-0 min-w-0 flex items-center justify-center px-4 pt-4">
        <div className="w-96 h-96 max-w-[85%] max-h-[40dvh] aspect-square shrink-0">
          <DotLottieReact
            src="/welcome.json"
            loop
            autoplay
            className="w-full h-full"
          />
        </div>
      </div>

      {/* Card อยู่ใต้จอ */}
      <div className="w-full min-w-0 shrink-0 px-4 pb-6 pt-2">
        <Card className="w-full max-w-md mx-auto rounded-2xl border-white/20 bg-white/95 shadow-xl backdrop-blur-sm dark:bg-neutral-900/95">
          <CardHeader className="text-center">
            <CardTitle className="text-2xl">Quran Assistant</CardTitle>
            <CardDescription>
              มาเริ่มต้นตั้งเป้าหมายการอ่านกุรอานไปด้วยกัน
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            {error && (
              <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700 dark:border-red-800 dark:bg-red-950/30 dark:text-red-300">
                {error}
              </div>
            )}

            <Button
              type="button"
              onClick={handleGoogleSignIn}
              disabled={loading}
              className="h-12 w-full text-base font-medium"
            >
              <svg className="mr-2 h-5 w-5" viewBox="0 0 24 24" aria-hidden>
                <path
                  fill="currentColor"
                  d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                />
                <path
                  fill="currentColor"
                  d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                />
                <path
                  fill="currentColor"
                  d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                />
                <path
                  fill="currentColor"
                  d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                />
              </svg>
              {loading ? 'กำลังเข้าสู่ระบบ...' : 'เข้าสู่ระบบด้วย Google'}
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
